module.exports = __webpack_public_path__ + "static/img/12areaA_08.1673440.png";


//////////////////
// WEBPACK FOOTER
// ./static/mycard/character1/通常使用/12areaA_08.png
// module id = 1008
// module chunks = 1